import { useLocation } from 'react-router-dom'

const useSignTableParams = () => {
  const { search } = useLocation()

  const query = new URLSearchParams(search)

  const deviceIdParam = query.get('deviceId')

  const userParam = query.get('user')

  const fromParam = query.get('date[from]')

  const toParam = query.get('date[to]')
  return {
    deviceIdParam,
    userParam,
    fromParam,
    toParam,
  }
}

export default useSignTableParams
